// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: '26.32.0',
  changelogUrl: 'https://changelog.dealpos.com/?categories=cat_OdB4Y3dLAB9Kp&view=complete',
  firebaseConfig: {
    apiKey: "AIzaSyDnnitFXpM8TglWKNpzu4ChgF98n25Rgvw",
    authDomain: "auth.dealpos.com",
    projectId: "devops-signin",
    storageBucket: "devops-signin.appspot.com",
    messagingSenderId: "412465165194",
    appId: "1:412465165194:web:03d806f6b6ab6f8b460e73",
    measurementId: "G-MNDBRJ5XZD"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
